export default __webpack_public_path__ + "static/media/metajb.777780e2.png";